import React from 'react'
import ApiUrl from '../../../configTools/apiUrl';

const ChatBoxes = ({openChatBox,setOpenChatBox}) => {
    const ChatBoxes = JSON.parse(localStorage.getItem("chat-boxes"));
  return (
    <>
    {ChatBoxes &&
        <div className='chat_boxes_container'>
            {
                ChatBoxes.map((item,index)=>{
                    return(
                        <>
                        {item.id != openChatBox.id &&

                            <div key={index} className='chat_boxes_item'>
                                <div 
                                    className='chat_boxes_item_image' 
                                    style={{
                                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.userimage})`
                                    }} 
                                    onClick={()=>{setOpenChatBox(item)}}
                                >
                                </div>
                            </div>
                        }
                        </>
                    )
                })
            }
        </div>
    }
    </>
  )
}

export default ChatBoxes
